import React, { useEffect, useState } from 'react';
import HK from 'factory/modules/HK';
import SearchBox from '../../contains/SearchBox';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { searchActiveAction } from 'components/common/header/contains/Search/action.js';
import { CARTAction, MBCashAvailableAction, userRoleAction } from 'components/common/header/action.js';
import CartIcon from './CartIcon';
import Link from 'components/Assets/LinkHref';
import { isLoginPopupAction } from 'components/common/login/action';
import IntersectionObserver from 'components/common/IntersectionObserver';
import { MenuNodeAction } from 'components/common/header/action';
import { headerPromotionalTextAction, menuPromotionalDataAction } from 'components/common/header/desktop/action.js';
import dynamic from 'next/dynamic';
import { __chatSupportPopup, __getImage, __getLoyaltyIconrender, __isMobile, __setLoyaltyDetail } from 'factory/modules/HK_service';
import styles from './desktop-header.module.scss';
import { convertToModule } from 'factory/utils/clientUtils';
import { isLogedInAction } from 'factory/store/actions/';
import { GritzoLogo } from 'components/SvgStore/index';
import config from 'factory/modules/config';
import LoyalityInfoPopup from 'components/Loyality/PDP/LoyalityInfoPopup';
import UniversalAnalytics from 'factory/modules/UniversalAnalytics';
// import './desktop-header.css'
// import SideMenu from './SideMenu';
// import OutsideClickListener from 'components/common/misc/OutsideClickListener.js'

const SideMenu = dynamic(() => import('./SideMenu'), { ssr: false });
const HeaderTopBar = (props) => {
    const { _searchActiveAction,/* _isLogedInReducer,*/ _CARTAction, /*_MBCashAvailableReducer, _pageType */ } = props;
    // states
    // const [goalMenu, setGoalMenu] = useState([])
    const [productMenu, setProductMenu] = useState([]);
    const [sideMenuActive, setSideMenuActive] = useState(false);
    const [loadHiddenHTML, setLoadHiddenHTML] = useState(false);
    const [searchText, setSearchText] = useState(null);
    const [isSearchFormSubmit, setIsSearchFormSubmit] = useState(false);
    const [searchFormEvent, setSearchFormEvent] = useState(null);
    const [currenPageType, setCurrentPageType] = useState('');
    const [activeIndex, setActiveIndex] = useState(null);
    const [activeMenu, setActiveMenu] = useState(false);
    const [addPremiumPopup, setAddPremiumPopup] = useState(false);

    useEffect(() => {
        onMountMenuData();
        cartDataCall();
    }, []);


    useEffect(() => {
        if (HK.getSearchParmas() && HK.getSearchParmas().txtQ) {
            setSearchText(HK.getSearchParmas().txtQ);
        }
    }, []);

    const handleTextChange = (e) => {
        setSearchText(e.target.value);
    };


    const triggerSearchClick = () => {
        const eventData = {
            widgetName: HK.config.eventNames.SEARCH_ICON.toLowerCase() || "",
            eventName: HK.config.eventNames.SEARCH_ICON || "",
            itemName: "search icon"
        };
        HK.triggerComponentClickEvent(eventData);
    };

    const triggerView = () => {
        return (inView) => {
            if (!inView) return;
            try {
                const eventData = {
                    widgetName: 'Header Search Icon',
                    eventName: "HEADER_SEARCH_ICON_VIEW",
                };
                HK.triggerComponentViewEvent(eventData);
            } catch (err) {
                console.log(err);
            }
        };
    };

    const onMountMenuData = async () => {
        const obj = {
            url: HK.config.APIS.menu.headerMenu,
            method: "GET"
        };
        HK.ajaxCall(obj).then(response => {
            if (response && response.data && response.data.results && !response.data.results.exception) {
                prepareMenuData(response.data.results);
                props._MenuNodeAction(response.data.results);
                props._headerPromotionalTextAction(response.data.results.menuPromotionalData);
                props._menuPromotionalDataAction(response.data.results);
                setLoadHiddenHTML(true);
            }
        }).catch(err => {
            console.log(err);
        });
    };

    const cartDataCall = () => {
        let isCartPage = window.location.pathname === '/cart/Cart.action';
        let _isAssumeReset = localStorage.getItem('_isUserLoggedIn') && !HK.Cookies.get('origId');
        if (_isAssumeReset) {
            localStorage.setItem('isUserLoggedIn', localStorage.getItem('_isUserLoggedIn'));
            HK.setCookieLoggedIn(localStorage.getItem('_isUserLoggedIn'));
            localStorage.removeItem('_isUserLoggedIn');
        }

        if (HK.loggedIn() || localStorage.getItem('isTMPUser') || HK.Cookies.get('assumeAuth') || _isAssumeReset) {
            HK.ajaxCall({
                url: HK.config.APIS.cart.summary,
                method: "GET"
            }).then(res => {
                const _res = res && res.data && res.data.results;
                if (_res && !_res.exception) {
                    _CARTAction(_res);
                    _res.hkUserLoyaltyDetailsDto && __setLoyaltyDetail(_res.hkUserLoyaltyDetailsDto);
                    props._userRoleAction(_res.hkUserLoyaltyDetailsDto && _res.hkUserLoyaltyDetailsDto.role);
                    // this.props._headerText("Your Cart (" + (res.data.results.noItemsInCart) + ")");
                }
            }).catch(() => { });
            HK.ajaxCall({
                url: HK.config.APIS.userFlow.userDetails + (isCartPage ? "?iscartpage=true" : ""),
                method: "GET"
            }).then(res => {
                const _res = res && res.data && res.data.results;
                if (_res && !_res.exception) {
                    let userData = {
                        uG: _res.gender !== null ? _res.gender : '',
                        uM: _res.email !== null ? _res.email : '',
                        uH: _res.id,
                        contact: _res.cntNum !== null ? _res.cntNum : '',
                        firstName: _res.nm != null && _res.nm.length > 0 ? _res.nm : "User",
                        birthDt: _res.birthDt !== null ? _res.birthDt : '',
                        tot_redeem_pts: _res.tot_redeem_pts !== null ? _res.tot_redeem_pts : 0
                    };
                    props._MBCashAvailableAction(_res && _res.tot_redeem_pts);
                    // this.refs._userFirstName.innerText = userData.firstName;
                    localStorage.setItem('userData', JSON.stringify(userData));
                    HK._dataLayer(userData);
                }
            }).catch(err => {
                if (err && err.response && err.response.status === 401) {
                    HK.postAjaxCall();
                }
            });
        }
    };

    const prepareMenuData = (data) => {
        const goalMenuData = [];
        const productMenuData = [];
        data.tpMenuNode.map(node => {
            if (node.type == 9) return;
            else if (node.type == 16) goalMenuData.push(node);
            else productMenuData.push(node);
        });
        setProductMenu(productMenuData);
        // setGoalMenu(goalMenuData)
    };

    const handleLogin = (widgetName, eventName) => {
        props._isLoginPopupAction({ isShow: true });
        const clickStream = {
            widgetName: widgetName,
            eventName: eventName,
        };
        HK.triggerComponentClickEvent(clickStream);
    };

    const triggerInViewEvent = (eventName, widgetName) => {
        return (inView) => {
            if (!inView) return;
            try {
                const eventData = {
                    widgetName: widgetName,
                    eventName: eventName,
                };
                if (eventData && eventData.eventName) {
                    HK.triggerComponentViewEvent(eventData);
                }
            } catch (err) {
                console.log(err);
            }
        };
    };


    const onAccClick = () => {
        setSideMenuActive(true);
        // const clickStream = {
        //     widgetName: widgetName,
        //     eventName: eventName,
        // }
        // HK.triggerComponentClickEvent(clickStream)
    };

    // const triggerClickEvent = (data) => {
    //     const clickStream = {
    //         widgetName: data,
    //         eventName: "MENU_ITEM_CLICK",
    //         itemName: data
    //     }
    //     HK.triggerComponentClickEvent(clickStream)
    // }

    // const triggerViewEvent = (eventName, widgetName, data) => {
    //     return (inView) => {
    //         if (!inView) return;
    //         try {
    //             const eventData = {
    //                 widgetName: widgetName,
    //                 eventName: eventName,
    //                 itemName: data
    //             }

    //             if (eventData && eventData.eventName) {
    //                 HK.triggerComponentViewEvent(eventData);
    //             }

    //         } catch (err) {
    //             console.log(err)
    //         }
    //     }
    // }

    // const triggerClick = (data) => {
    //     onMenuItemHover()
    //     const eventData = {
    //         widgetName: 'Cross Click',
    //         eventName: "CROSS_CLICK",

    //     }
    //     HK.triggerComponentClickEvent(eventData);
    // }
    // const clickHandler = () => {
    //     const eventData = {
    //         widgitName: "Top_Navigation",
    //         eventName: "Top_Navigation",
    //         Itemname: 'Mb_Wallet',
    //         quantity: _MBCashAvailableReducer && parseInt(_MBCashAvailableReducer) || 0
    //     }

    //     HK.triggerComponentClickEvent(eventData);

    // }
    useEffect(() => {
        if (HK.loggedIn()) {
            props._isLogedInAction(true);
        }
    }, []);

    // const triggerInViewEventW = () => {
    //     return (inView) => {
    //         if (!inView) return;
    //         try {
    //             let eventData;
    //             eventData = {
    //                 widgitName: "MB_WALLET_ICON",
    //                 eventName: "MB_WALLET_ICON_view",
    //                 quantity: _MBCashAvailableReducer && parseInt(_MBCashAvailableReducer) || 0
    //             }

    //             HK.triggerComponentViewEvent(eventData);
    //         } catch (err) {
    //             console.log(err)
    //         }
    //     }
    // }
    // const onMenuItemHover = (skipHide) => {
    //     if (!skipHide) {
    //         _searchActiveAction(false)
    //     }
    // }
    // const onAuthenticityClick = () => {
    //     const element = document.getElementById('AYP')
    //     element.scrollIntoView({
    //         behavior: 'smooth'
    //     })
    // }
    // const nameBreaker = (name) => {
    //     let temp;
    //     temp = name.split(" ")[0];
    //     return temp ? temp.substr(0, 1).toUpperCase() + temp.substr(1) : "Guest";
    // };

    useEffect(() => {
        if (props.pageType) {
            setCurrentPageType(props.pageType);
        }
        else {
            setCurrentPageType(window.pageType);
        }
    }, [props.pageType]);

    const userAccountIcon = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M16.6667 17.5V15.8333C16.6667 14.9493 16.3155 14.1014 15.6904 13.4763C15.0653 12.8512 14.2174 12.5 13.3334 12.5H6.66671C5.78265 12.5 4.93481 12.8512 4.30968 13.4763C3.68456 14.1014 3.33337 14.9493 3.33337 15.8333V17.5" stroke="#002140" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M9.99996 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 9.99996 2.5C8.15901 2.5 6.66663 3.99238 6.66663 5.83333C6.66663 7.67428 8.15901 9.16667 9.99996 9.16667Z" stroke="#002140" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>;


    // const getMenuImage = (name) => {
    //     let result = "";
    //     if (name === "Health Drinks") {
    //         result = HK.getImage("/newGritzo/Supermilk.svg")
    //     } else if (name === "Gummies") {
    //         result = HK.getImage("/newGritzo/Gummies.svg")
    //     } else if (name === "Spreads") {
    //         result = HK.getImage("/newGritzo/Spread.svg")
    //     }
    //     return result;
    // }
    const handleChatBot = () => {
        __chatSupportPopup(true);
    };

    const createTempUser = () => {
        if (!(localStorage.getItem('isUserLoggedIn') !== null && localStorage.getItem('isUserLoggedIn') !== 'false' && HK.Cookies.get('authtoken'))) {
            HK.loader(true);
            let reqObj = {
                method: 'get',
                url: HK.config.APIS.userFlow.tempUserCreate
            };
            HK.ajaxCall(reqObj).then((res) => {
                const _res = res && res.data && res.data.results;
                if (_res && !_res.exception) {
                    HK.Cookies.set('authtoken', '"' + _res.authToken + '"', 365);
                    localStorage.setItem('isUserLoggedIn', _res.user.id);
                    localStorage.setItem('isTMPUser', 1);
                    HK.setCookieLoggedIn(_res.user.id, 1);
                    handleLoyaltyClick();
                }
            }).catch(err => {
                HK.errorPopup("Something went wrong, please try again.", 'Got: exception::' + reqObj.url);
                HK.reportErrorToDashboard({
                    stackTrace: new Error().stack,
                    errorMessage: err
                });
            }).finally(() => {
                HK.loader(false);
            });
        }
        else {
            handleLoyaltyClick();
        }
    };


    const handleLoyaltyClick = () => {
        if (props._userRoleReducer !== config.LOYALITY_ROLES.PREMIUM_USER) {
            setAddPremiumPopup(true);
        } else {
            window.location.href = '/loyalty';
        }
        let data = {
            event_name: 'select_promotion',
            'reward_points_available': '',
            'value': '',
            'promotion_name': '',
            'creative_name': '',
            'creative_slot': '',
            items: [
                {
                    'item_name': 'Icon_click',
                    'promotion_name': 'Loyalty Feature'
                }
            ]
        };
        UniversalAnalytics.LoyaltyDataLayer(data);
    };

    return (
        <>
            {!HK.fromApp() && <IntersectionObserver className={convertToModule(styles, "header-top__container")} onChange={triggerInViewEvent("MENU_HEADER", "Menu Header")}>
                <div className={convertToModule(styles, "container-wrap")}  >
                    <Link to='/'>
                        <div dangerouslySetInnerHTML={{ __html: GritzoLogo }} />
                    </Link>
                    <div className={convertToModule(styles, 'header-headings')} onMouseLeave={() => setActiveMenu(false)}>
                        {
                            productMenu && productMenu.length > 0 ? productMenu.map((ele, index) => {
                                return (
                                    <div key={index} className={convertToModule(styles, 'blog-heading')} >
                                        <a onMouseEnter={() => { setActiveIndex(1); setActiveMenu(ele.nm); }} className={convertToModule(styles, 'blog-link')}> {ele.nm} <svg aria-hidden="true" focusable="false" role="presentation" class="icon-caret" viewBox="0 0 10 6">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                                            </path></svg></a>
                                    </div>
                                );
                            })
                                :
                                <div className={convertToModule(styles, 'blog-heading-no-data')}></div>
                        }
                        <div onMouseLeave={() => setActiveIndex(null)}>
                            {
                                activeIndex &&
                                productMenu && productMenu.map((ele, k) => {
                                    if (ele.nm === activeMenu)
                                        return <ul onMouseLeave={() => { setActiveIndex(null), setActiveMenu(false); }} key={k} className={convertToModule(styles, 'header__submenu list-menu list-menu--disclosure caption-large motion-reduce megaMenu')} >
                                            <div className={convertToModule(styles, 'first-menu menu-section')}>
                                                {
                                                    ele.ch && ele.ch.map((ele2, k2) => {
                                                        let url, navKey;
                                                        navKey = ele2.navKey;
                                                        if (ele2 && ele2.landingPageCustomUrl) {
                                                            url = ele2.landingPageCustomUrl;
                                                        }
                                                        else if (navKey) {
                                                            url = ele2.urlFragment + "?navKey=" + navKey;
                                                        } else {
                                                            url = ele2.urlFragment || '';
                                                        }

                                                        return <span key={k2}>
                                                            <a href={url} className={convertToModule(styles, 'header__menu-item list-menu__item link link--text focus-inset caption-large')} >
                                                                {ele2.nm}
                                                            </a>
                                                        </span>;



                                                    })
                                                }
                                            </div>
                                            {
                                                productMenu && productMenu.length > 0 && productMenu.map((ele, index) => {
                                                    return (
                                                        ele && ele.ch && ele.ch.length > 0 && ele.ch.map((ele3, k3) => {

                                                            if (ele3 && ele3.image && ele3.image.o_link != null && activeMenu === ele.nm) {
                                                                return (
                                                                    <div key={`${k3}_${index}`} className={convertToModule(styles, 'subset-menu menu-section')}>
                                                                        {ele3.image.o_link ? <a href={`${ele3.urlFragment}?navKey=${ele3.navKey}`} className={convertToModule(styles, 'menu-category-banner')} >
                                                                            <img loading="lazy" width="120" height="80" src={ele3.image.o_link} />
                                                                        </a> : ''}
                                                                    </div>
                                                                );
                                                            } else {
                                                                return '';
                                                            }
                                                        })
                                                    );
                                                })
                                            }
                                        </ul>;
                                })
                            }
                        </div>
                        {/* <div className={convertToModule(styles, 'blog-heading')} >
                            <a onMouseEnter={() => setActiveIndex(1)} className={convertToModule(styles, 'blog-link')}> SHOP BY PRODUCT <svg aria-hidden="true" focusable="false" role="presentation" class="icon-caret" viewBox="0 0 10 6">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                                </path></svg></a>
                        </div> */}
                        {/* <div className={convertToModule(styles, 'blog-heading')} >
                            <a onMouseEnter={() => setActiveIndex(2)} className={convertToModule(styles, 'blog-link')}> Shop by Concern <svg aria-hidden="true" focusable="false" role="presentation" class="icon-caret" viewBox="0 0 10 6">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                                </path></svg></a>
                        </div> */}
                        {/* <div className={convertToModule(styles, 'blog-heading')}>
                            <a className={convertToModule(styles, currenPageType =='article' ? 'blog-link active' : 'blog-link')} href='/articles'> Blog </a>
                        </div> */}
                        {/* <div className={convertToModule(styles, 'contactus-heading ')}>
                            <a className={convertToModule(styles, currenPageType == 'contact-us' ? 'contactus-link active' : 'contactus-link')} href='/pages/contact-us'>Contact Us</a>
                        </div> */}
                        <div className={convertToModule(styles, 'aboutus-heading')}>
                            <a onMouseEnter={() => { setActiveMenu(null); }} className={convertToModule(styles, currenPageType == 'about-us' ? 'aboutus-link active' : 'aboutus-link')} href='/pages/about-us'> About Us</a>
                        </div>
                        <div className={convertToModule(styles, 'contactus-heading')}>
                            <div onMouseEnter={() => { setActiveMenu(null); }} className={convertToModule(styles, 'contactus-link')} onClick={handleChatBot}>Chat Support</div>
                        </div>
                    </div>
                    <div className={convertToModule(styles, "header-top__nav")}>
                        <div className={convertToModule(styles, 'search-bar')}>

                            <svg id="_Trailing_Icon" data-name="??Trailing Icon" xmlns="http://www.w3.org/2000/svg" width="18.832" height="18.83" viewBox="0 0 18.832 18.83">
                                <rect id="Boundary" width="18" height="18" fill="none" />
                                <path id="Union_2" data-name="Union 2" d="M16.646,17.658l-4.59-4.591c.007,0,1.008-1.01,1.011-1.01l4.591,4.589a.716.716,0,0,1-.544,1.184A.724.724,0,0,1,16.646,17.658ZM6.626,14.3a7.136,7.136,0,1,1,6.084-2.6L11.7,12.709a7.174,7.174,0,0,1-4.526,1.609C6.99,14.318,6.807,14.31,6.626,14.3ZM4.282,2.191A5.734,5.734,0,1,0,7.155,1.42,5.738,5.738,0,0,0,4.282,2.191ZM2.5,7.779a.717.717,0,0,1-.359-.621,5.023,5.023,0,0,1,5.02-5.02.717.717,0,1,1,0,1.434A3.586,3.586,0,0,0,3.573,7.157a.716.716,0,0,1-.36.621.705.705,0,0,1-.359.1A.714.714,0,0,1,2.5,7.779Z" transform="translate(1.001 1.001)" fill="#414c58" />
                            </svg>

                            <form className={convertToModule(styles, 'search-input-text-box-form')} onSubmit={(e) => { setIsSearchFormSubmit(true); setSearchFormEvent(e); }}>
                                <input onClick={() => { _searchActiveAction(true); triggerSearchClick(); }} onChange={(e) => { triggerView(); handleTextChange(e); }} value={searchText} type='text' placeholder='' className={convertToModule(styles, 'search-input-text-box')} />
                            </form>
                        </div>

                    </div>


                    {
                        <div className={convertToModule(styles, "header-top__icons")}>
                            {/* <Search /> */}
                            {/* <WishListIcon isMobile={HK.isMobile()} pageType={props._pageType} isWishlist={props.isWishlist} /> */}

                            {
                                __getLoyaltyIconrender(props._pageType) ?
                                    <svg width="24" height="19" viewBox="0 0 24 19" fill="none" onClick={() => createTempUser()}>
                                        <path d="M23.1831 6.30994L23.1821 6.30805L20.2113 0.989836L20.2113 0.989833L20.2105 0.988352C20.1283 0.843645 19.9737 0.756491 19.806 0.761161L4.19073 0.760083C4.03007 0.757008 3.87353 0.839836 3.78888 0.984736L3.78884 0.984714L3.78658 0.988775L0.82019 6.30028C0.817362 6.30486 0.814766 6.30939 0.812383 6.31385C0.809769 6.31812 0.807222 6.32257 0.804764 6.32722C0.800178 6.3359 0.796305 6.34448 0.793041 6.35289C0.781533 6.37956 0.774704 6.40443 0.770378 6.42558L0.776964 6.42693L0.770378 6.42559C0.765088 6.45146 0.76 6.48463 0.76 6.5222C0.76 6.56598 0.766993 6.60803 0.779358 6.64662C0.786936 6.67284 0.801095 6.71692 0.832559 6.76308L0.832249 6.76329L0.840419 6.77395C0.84225 6.77634 0.844077 6.77863 0.845887 6.78083C0.854326 6.79507 0.866592 6.81281 0.884078 6.83074L11.6536 18.0784L11.659 18.0872L11.6802 18.1079C11.703 18.1302 11.7253 18.1475 11.7455 18.1614L11.7703 18.1783L11.7812 18.1823C11.7914 18.1887 11.801 18.1936 11.8095 18.1975C11.8262 18.2052 11.8407 18.2095 11.8478 18.2115C11.8523 18.213 11.8561 18.2142 11.8584 18.215L11.8591 18.2152C11.8621 18.2162 11.8632 18.2166 11.8635 18.2167L11.8635 18.2168L11.8718 18.2195C11.9126 18.2328 11.9575 18.24 12.0013 18.24C12.0411 18.24 12.0763 18.2344 12.1067 18.2271C12.123 18.2241 12.1346 18.2206 12.1388 18.2193C12.1518 18.2154 12.1625 18.2112 12.1671 18.2095L12.2125 18.1917L12.2191 18.1852C12.2276 18.181 12.2353 18.1766 12.2422 18.1722C12.2493 18.168 12.2556 18.1638 12.2611 18.1599C12.2616 18.1596 12.262 18.1593 12.2625 18.159L12.2824 18.146L12.2992 18.1296C12.3225 18.1119 12.337 18.0944 12.3434 18.0865C12.3448 18.0847 12.3461 18.083 12.3472 18.0815L23.1163 6.83394L23.1244 6.82549L23.1287 6.82003L23.1306 6.81799L23.1377 6.81036C23.1478 6.79932 23.1709 6.7736 23.1899 6.73597L23.1918 6.7323C23.1926 6.7308 23.1938 6.7287 23.1951 6.72617C23.1968 6.72288 23.1989 6.71885 23.2011 6.71448C23.2058 6.7048 23.2153 6.68484 23.2227 6.65839C23.2286 6.64046 23.2354 6.61464 23.2374 6.58336C23.246 6.4997 23.2341 6.40319 23.1831 6.30994ZM13.0837 1.64789H19.1255L17.2534 5.75743L13.0837 1.64789ZM17.6779 6.96599H21.7466L13.6075 15.4719L17.6779 6.96599ZM16.3088 6.07932H11.9987H7.68869L11.9987 1.82917L16.3088 6.07932ZM6.31939 6.96599L10.3907 15.4708L2.25073 6.96599H6.31939ZM4.87413 1.64789H10.9136L6.74617 5.75526L4.87413 1.64789ZM20.2861 2.9594L20.2862 2.9595L22.0278 6.07932H18.0898L19.8599 2.19507L20.2861 2.9594ZM7.31236 6.96604H16.6861L11.9987 16.7616L7.31236 6.96604ZM1.96995 6.07948L4.13857 2.19651L5.91071 6.07948H1.96995Z" fill="#E57321" stroke="#E57321" stroke-width="0.48" />
                                    </svg>
                                    : <></>
                            }

                            {
                                currenPageType !== 'cart' &&
                                currenPageType !== 'selectPayment' &&
                                currenPageType !== 'checkout' &&
                                <CartIcon cartHandler={props.cartHandler} cartClick={true} isMobile={HK.isMobile()} />}
                            {
                                HK.loggedIn() ?
                                    <button className={convertToModule(styles, 'mb-btn acc user-icon-cntnr ' + HK.loggedIn() ? 'btn-white user-icon-cntnr' : '')}
                                        onMouseEnter={() => onAccClick("HEADER_ACCOUNT", "Header Account")}
                                        onMouseLeave={() => setSideMenuActive(false)}
                                    >
                                        {userAccountIcon}
                                        {
                                            !__isMobile() && props._userRoleReducer === config.LOYALITY_ROLES.PREMIUM_USER ?
                                                <img src={__getImage('/loyalty/dark_loyalty_icon.svg')} alt='dark_loyalty_icon' className={styles['loyalty-icon-logged-in']} />
                                                : <></>
                                        }
                                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                                            <g id="Group_98695" data-name="Group 98695" transform="translate(-18 -43)">
                                                <rect id="_Container_l_Color" data-name="???? Container l Color" width="32" height="32" rx="6" transform="translate(18 43)" fill="none" />
                                                <rect id="_Container_l_Color-2" data-name="???? Container l Color" width="29" height="29" rx="4" transform="translate(20 44)" fill="#20262e" />
                                                <g id="Group_96201" data-name="Group 96201" transform="translate(27.603 51.648)">
                                                    <path id="Path_8069" data-name="Path 8069" d="M148.112,75.05a9.433,9.433,0,0,1-14.143,0,7.708,7.708,0,0,1,4.076-4.1,4.541,4.541,0,1,1,5.99,0A7.668,7.668,0,0,1,148.112,75.05Zm0,0" transform="translate(-133.969 -63)" fill="#ffe674" />
                                                    <path id="Path_8070" data-name="Path 8070" d="M263.071,75.05A9.425,9.425,0,0,1,256,78.24V63a4.539,4.539,0,0,1,2.993,7.952A7.668,7.668,0,0,1,263.071,75.05Zm0,0" transform="translate(-249.124 -62.999)" fill="#ffbe00" />
                                                </g>
                                            </g>
                                        </svg>
                                        <div className={convertToModule(styles, 'user-info-section-data')}>
                                            <span className={convertToModule(styles, 'user-info-data')}>
                                                Hello,
                                            </span>
                                            <div>
                                                <span className={convertToModule(styles, 'user-info-data-nm')}>
                                                    {__localStorageGet('userData') && __localStorageGet('userData').firstName}
                                                </span>
                                                <svg className={convertToModule(styles, sideMenuActive ? 'active-profile-page' : 'non-active-profile-page')} xmlns="http://www.w3.org/2000/svg" width="10.938" height="6.373" viewBox="0 0 10.938 6.373">
                                                    <path id="Path_150160" data-name="Path 150160" d="M3.019,6.351l3.095,3.08a.882.882,0,0,1-1.245,1.25L.26,6.094h0a.883.883,0,0,1,0-1.249h0L4.869.257a.882.882,0,0,1,1.245,1.25L3.019,4.587l-.878.874Z" transform="translate(0 6.373) rotate(-90)" fill="#20262e" />
                                                </svg>
                                            </div>
                                        </div>
                                        {
                                            sideMenuActive &&
                                            <div className={convertToModule(styles, 'bordre-bottom')} />} */}

                                        {/* {localStorage.getItem('userData').uM}
                                         Account */}
                                    </button>
                                    :
                                    <div className={styles['user-icon-cntnr']} onClick={() => handleLogin("HEADER_SIGNUP", "Header Signup")}>
                                        {userAccountIcon}
                                        {
                                            !__isMobile() && props._userRoleReducer === config.LOYALITY_ROLES.PREMIUM_USER ?
                                                <img src={__getImage('/loyalty/dark_loyalty_icon.svg')} alt='dark_loyalty_icon' className={styles['loyalty-icon']} />
                                                : <></>
                                        }

                                    </div>
                                // <div className={convertToModule(styles, "mb-btn mb-btn-login")} onClick={() => handleLogin("HEADER_SIGNUP", "Header Signup")}>
                                //     Login/Sign Up
                                // </div>
                            }

                        </div>
                    }

                    {/* {
                        _searchActiveReducer &&
                        <img className={convertToModule(styles, 'header-top__close-search-btn')} src={HK.getImage('/header/searchbox/close-search-icon.svg')} onClick={() => { _searchActiveAction(false); triggerClick(true) }} />
                    } */}


                </div>
                <div className={convertToModule(styles, "header-side-menu HK-pagecontainer")}>
                    {
                        loadHiddenHTML &&
                        <SearchBox handleTextChange={handleTextChange} searchFormEvent={searchFormEvent} isSearchFormSubmit={isSearchFormSubmit} _searchActiveAction={_searchActiveAction} searchText={searchText} />
                    }
                </div>
                {
                    addPremiumPopup ?
                        <LoyalityInfoPopup setAddPremiumPopup={setAddPremiumPopup} />
                        : <></>
                }
                {/* {
                    _headerPromotionalTextReducer === 0
                        ?
                        (!HK.isMobile(props) &&
                            <div className={convertToModule(styles, 'promo_skel')} />)
                        :
                        (_headerPromotionalTextReducer &&
                            <PromoText text={_headerPromotionalTextReducer} />)

                } */}
                <div className={convertToModule(styles, "header-side-menu HK-pagecontainer")}>
                    <div className={convertToModule(styles, "extra-path")} onMouseEnter={() => setSideMenuActive(true)} onMouseLeave={() => setSideMenuActive(false)}></div>
                    <SideMenu className={HK.loggedIn() && sideMenuActive ? 'active' : ''} onMouseLeave={() => setSideMenuActive(false)} onMouseEnter={() => setSideMenuActive(true)}
                        closeMenu={() => setSideMenuActive(false)} {...props} />
                </div>

                {/* </div> */}
            </IntersectionObserver>
            }
        </>
    );
};


function mapStateToProps(state) {
    return {
        _isLogedInReducer: state.isLogedInReducer,
        _searchActiveReducer: state.searchActiveReducer,
        _headerPromotionalTextReducer: state.headerPromotionalTextReducer,
        _MBCashAvailableReducer: state.MBCashAvailableReducer,
        _pageType: state.pageTypeReducer,
        _userRoleReducer: state.userRoleReducer
    };
}
// Store value
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        _searchActiveAction: searchActiveAction,
        _CARTAction: CARTAction,
        _isLoginPopupAction: isLoginPopupAction,
        _MenuNodeAction: MenuNodeAction,
        _headerPromotionalTextAction: headerPromotionalTextAction,
        _MBCashAvailableAction: MBCashAvailableAction,
        _isLogedInAction: isLogedInAction,
        _menuPromotionalDataAction: menuPromotionalDataAction,
        _userRoleAction: userRoleAction,

    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(HeaderTopBar);